import React from 'react';

const ViewDetailPrescription = ({ prescription }) => {
  // If no prescription, show a placeholder
  if (!prescription) return <div className="alert alert-info">No prescription selected</div>;

  // Render medications table
  const renderMedicationsTable = () => {
    // If there's no medications array, show single medication
    if (!Array.isArray(prescription.medications)) {
      return (
        <table className="table table-striped text-center">
          <thead className="table-info">
            <tr>
              <th>Medicine ID</th>
              <th>Dosage</th>
              <th>Frequency</th>
              <th>Duration</th>
              <th>Instructions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{prescription.medicineId || 'N/A'}</td>
              <td>{prescription.dosage || 'N/A'}</td>
              <td>{prescription.frequency || 'N/A'}</td>
              <td>{prescription.duration || 'N/A'}</td>
              <td>{prescription.instructions || 'N/A'}</td>
            </tr>
          </tbody>
        </table>
      );
    }
    
    // When medications is an array
    const medsToShow = Array.isArray(prescription.medications) ? prescription.medications : [];
    
    return (
      <table className="table table-striped text-center">
        <thead className="table-info">
          <tr>
            <th>Medicine ID</th>
            <th>Dosage</th>
            <th>Frequency</th>
            <th>Duration</th>
            <th>Instructions</th>
          </tr>
        </thead>
        <tbody>
          {medsToShow.length > 0 ? (
            medsToShow.map((med, index) => (
              <tr key={index}>
                <td>{med.medicineId || 'N/A'}</td>
                <td>{med.dosage || 'N/A'}</td>
                <td>{med.frequency || 'N/A'}</td>
                <td>{med.duration || 'N/A'}</td>
                <td>{med.instructions || 'N/A'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center">No medications</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  };

  return (
    <div className="container-fluid p-0">
      <div className="row align-items-center mb-3">
        <div className="col">
          <h3>Prescription Details</h3>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Prescription ID</label>
          <input 
            type="text" 
            className="form-control" 
            value={prescription.id || 'N/A'} 
            readOnly 
          />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Date Prescribed</label>
          <input 
            type="text" 
            className="form-control" 
            value={prescription.datePrescribed || 'N/A'} 
            readOnly
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Doctor ID</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={prescription.doctorId || 'N/A'} 
              readOnly
            />
          </div>
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Doctor Name</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={prescription.doctorName || 'N/A'} 
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Patient ID</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={prescription.patientId || 'N/A'} 
              readOnly
            />
          </div>
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Patient Name</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={prescription.patientName || 'N/A'} 
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="mb-3">
        <h4>Clinical Information</h4>
        <div className="row">
          <div className="col-md-12 mb-3">
            <label className="form-label fw-bold">Symptoms</label>
            <div className="input-group mb-3">
              <textarea
                className="form-control"
                rows="3"
                value={prescription.symptoms || 'No symptoms recorded'}
                readOnly
              ></textarea>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mb-3">
            <label className="form-label fw-bold">Diseases</label>
            <div className="input-group mb-3">
              <textarea
                className="form-control"
                rows="3"
                value={prescription.diseases || 'No diseases recorded'}
                readOnly
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-3">
        <h4>Medications</h4>
        <div className="table-responsive">
          {renderMedicationsTable()}
        </div>
      </div>

      <div className="mb-3">
        <h4>Tests</h4>
        <div className="input-group mb-3">
          <textarea
            className="form-control"
            rows="3"
            value={prescription.tests || 'No tests prescribed'}
            readOnly
          ></textarea>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Refills</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={prescription.refills || '0'} 
              readOnly
            />
          </div>
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Consultation Type</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={prescription.consultationType || 'Regular'} 
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDetailPrescription;